import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="mb-4 text-6xl font-bold text-slate-800 dark:text-slate-200">404</h1>
      <h2 className="mb-6 text-2xl font-medium text-slate-700 dark:text-slate-300">
        {t('notFound.title', 'Page Not Found')}
      </h2>
      <p className="mb-8 max-w-md text-slate-600 dark:text-slate-400">
        {t(
          'notFound.message',
          'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
        )}
      </p>
      <Link
        to="/"
        className="rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-white transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-500 dark:text-white dark:hover:bg-indigo-400"
      >
        {t('notFound.backHome', 'Back to Home')}
      </Link>
    </div>
  );
};
